export default "__VITE_ASSET__Cb_r_yaz__"